import { AgencyAdapter } from './reducer'

export const { selectAll: selectAllAgencies, selectById: selectAgencyById } =
  AgencyAdapter.getSelectors(state => state.agencies)
